import { render, staticRenderFns } from "./result_cchjq.vue?vue&type=template&id=b07661cc&scoped=true"
import script from "./result_cchjq.vue?vue&type=script&lang=js"
export * from "./result_cchjq.vue?vue&type=script&lang=js"
import style0 from "./result_cchjq.vue?vue&type=style&index=0&id=b07661cc&prod&lang=scss&scoped=true"
import style1 from "./result_cchjq.vue?vue&type=style&index=1&id=b07661cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07661cc",
  null
  
)

export default component.exports